import { List, Record } from 'immutable';

export default Record({
    amount: 0,
    companyId: null,
    createdAt: '',
    id: null,
    orders: List(),
    platform: '',
    status: '',
    stripeId: '',
    updatedAt: '',
}, 'Charge');
